import { Link } from "wouter";
import { Layout } from "@/components/layout";
import { useAuth } from "@/hooks/use-auth";
import { accessibleGroups, accessibleItems, groupLandingHref } from "@/lib/pagePermissions";
import { motion } from "framer-motion";

export default function Home() {
  const { user } = useAuth();
  const groups = accessibleGroups(user);

  return (
    <Layout>
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-duffells-grey">
            Welcome{user?.name ? `, ${user.name.split(" ")[0]}` : ""}
          </h1>
          <p className="text-duffells-grey/60 mt-1">
            {groups.length > 0
              ? "Pick a section to get started."
              : "You don't have access to any sections yet. Ask an administrator to grant you page permissions."}
          </p>
        </div>

        {groups.length > 0 && (
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {groups.map((g, i) => {
              const Icon = g.icon;
              const items = accessibleItems(user, g);
              const landing = groupLandingHref(user, g);
              return (
                <motion.div
                  key={g.key}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.25, delay: i * 0.04 }}
                >
                  <Link
                    href={landing}
                    className="group block h-full bg-white rounded-2xl border border-slate-200 p-6 hover:border-primary hover:shadow-lg hover:shadow-primary/5 transition-all"
                    data-testid={`home-tile-${g.key}`}
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary group-hover:text-white transition-colors">
                        <Icon className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
                      </div>
                      <div className="min-w-0 flex-1">
                        <h2 className="font-semibold text-duffells-grey group-hover:text-primary transition-colors">
                          {g.label}
                        </h2>
                        <p className="text-sm text-duffells-grey/60 mt-1">{g.description}</p>
                      </div>
                    </div>
                    {items.length > 1 && (
                      <div className="mt-4 pt-4 border-t border-slate-100">
                        <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-duffells-grey/50">
                          {items.map((it) => (
                            <span key={it.href} className="inline-flex items-center gap-1">
                              <it.icon className="w-3 h-3" />
                              {it.label}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </Link>
                </motion.div>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
